import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Form, Button, Container, Card, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import PasswordInput from '../components/PasswordInput';

// Tarea 027b — modelo directo de RegisterPage.js/AcceptInvitationPage.js.
const ResetPasswordPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [invalidToken, setInvalidToken] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors([]);
        setInvalidToken(false);

        if (password !== confirmPassword) {
            return setErrors([t('resetPasswordPage.passwordsDoNotMatch')]);
        }

        setIsLoading(true);
        try {
            await api.post(`/auth/reset-password/${token}`, { password, confirmPassword });
            navigate('/login', { state: { message: t('resetPasswordPage.success') } });
        } catch (err) {
            if (err.response?.data?.code === 'INVALID_OR_EXPIRED_TOKEN') {
                setInvalidToken(true);
            } else if (err.response?.data?.errors) {
                setErrors(err.response.data.errors.map((key) => t(key)));
            } else {
                setErrors([err.response?.data?.message || t('resetPasswordPage.failed')]);
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <Card style={{ width: '100%', maxWidth: '400px' }}>
                <Card.Body>
                    <h2 className="text-center mb-4">{t('resetPasswordPage.title')}</h2>

                    {invalidToken ? (
                        <>
                            <Alert variant="danger">{t('resetPasswordPage.invalidOrExpired')}</Alert>
                            <div className="text-center">
                                <Link to="/forgot-password">{t('resetPasswordPage.requestNewLink')}</Link>
                            </div>
                        </>
                    ) : (
                        <>
                            {errors.length > 0 && (
                                <Alert variant="danger">
                                    {errors.map((errorMsg, index) => (
                                        <div key={index}>{errorMsg}</div>
                                    ))}
                                </Alert>
                            )}
                            <Form onSubmit={handleSubmit}>
                                <PasswordInput
                                    controlId="password"
                                    label={t('resetPasswordPage.passwordLabel')}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    disabled={isLoading}
                                />
                                <PasswordInput
                                    controlId="confirmPassword"
                                    label={t('resetPasswordPage.confirmPasswordLabel')}
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                    disabled={isLoading}
                                />
                                <div className="d-grid">
                                    <Button variant="primary" type="submit" disabled={isLoading}>
                                        {isLoading ? t('resetPasswordPage.saving') : t('resetPasswordPage.submitButton')}
                                    </Button>
                                </div>
                            </Form>
                        </>
                    )}

                    <div className="text-center mt-3">
                        <Link to="/login">{t('verifyEmailPage.backToLogin')}</Link>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default ResetPasswordPage;
